// Centralized policy for listing visibility in search and feeds

export const LISTING_VISIBILITY = {
  PUBLIC: 'public-listing',
  PRIVATE_LINK_ONLY: 'private-link-only-listing',
};

/**
 * Returns true if a listing should be considered hidden from public discovery
 * (aka "unlisted"). Supports both the legacy boolean flag and the new
 * visibility enum.
 */
export const isListingUnlisted = listing => {
  const publicData = listing?.attributes?.publicData || {};
  const { visibility, unlisted, listingType } = publicData;

  const hasLegacyUnlistedFlag = unlisted === true;
  const hasPrivateVisibility = visibility === LISTING_VISIBILITY.PRIVATE_LINK_ONLY;
  const isCampaignInbox =
    listingType === 'campaign-inbox' || listing?.attributes?.title === '[System] Inbox';
  return hasLegacyUnlistedFlag || hasPrivateVisibility || isCampaignInbox;
};

/**
 * Returns true if a listing should be visible in public discovery contexts.
 * Enforces common constraints: published, not deleted, not unlisted.
 */
export const isListingVisible = listing => {
  const attributes = listing?.attributes || {};
  const isPublished = attributes.state === 'published';
  const isNotDeleted = !attributes.deleted;
  const isNotUnlisted = !isListingUnlisted(listing);
  return Boolean(isPublished && isNotDeleted && isNotUnlisted);
};

/**
 * Filters out listings that should not be shown in public discovery contexts.
 */
export const filterVisibleListings = listings => {
  return Array.isArray(listings) ? listings.filter(isListingVisible) : [];
};
